"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Tooltip_1 = require("./Tooltip");
exports.default = Tooltip_1.default;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/Tooltip/index.js
// module id = 650
// module chunks = 8